import { CAMPAIGN_STATUS_COLORS } from "../../../utils/colors";
import { toScreamingSnakeCase } from "../../../utils/constants";

export const default_create_update_campaign_payload = {
    "campaign_id": 0,
    "campaign_title": "",
    "campaign_description": "",
    "contact_list_id": 0,
    "campaign_message_type_id": 0,
    "flag_template": true,
    "whatsapp_template_id": 0,
    "waba_id": "",
    "meta_integration_whatsapp_phone_number_id": 0,
    "campaign_message_content": "",
    "campaign_message_sending_date": "",
    "campaign_message_sending_time": "",
    "static_delay_ms": 0,
    "contact_tag_id": [],
    "campaign_variable": [
        {
            "campaign_variable_id": 0,
            "contact_field_id": 0,
            "whatsapp_template_dynamic_variable_id": 0,
            "campaign_variable_name": "",
            "campaign_variable_fallback_value": ""
        }
    ],  
    "campaign_carousel_card": [
        {
            "whatsapp_template_carousel_variation_id": 0, 
            "campaign_carousel_card_index": 0,
            "campaign_carousel_card_id": 0, 
            "campaign_variable": [{
                "campaign_variable_id": 0,
                "contact_field_id": 0,
                "whatsapp_template_dynamic_variable_id": 0,
                "campaign_variable_name": "",
                "campaign_variable_fallback_value": ""
            }]
        }
    ],
    "campaign_contact_filter": [],
}

export const default_deployment_trigger_payload_data = {
    integrated_channel_deployment_trigger_id: "",
    integrated_channel_id: "",
    campaign_id: "",
    condition_group: null,
    chatbot_id: "",
    chatbot_step_id: "",
}

export const default_deployment_trigger_payload = {
    flag_action: false,
    deployment_trigger_data: [default_deployment_trigger_payload_data]
}

export const emptyCampaignObject = {
    campaign_id: -1,
    campaign_title: 'All Campaigns',
    contact_list_id: -1,
    contact_list_name: '',
    campaign_message_type_id: 0,
    campaign_message_type_name: '',
    flag_template: false,
    whatsapp_template_id: 0,
    whatsapp_template_name: '',
    whatsapp_template_description: '',
    meta_integration_whatsapp_id: 0,
    meta_integration_whatsapp_phone_number_id: 0,
    waba_id: '',
    waba_name: '',
    phone_number_id: '',
    display_phone_number: '',
    campaign_message_content: null,
    campaign_message_sending_date: null,
    campaign_message_sending_time: null,
    campaign_execution_status_id: 0,
    campaign_execution_status_name: '',
    created_at_timestamp: '',
    updated_at_timestamp: null,
    total_campaign_contact: 0,
    total_sent_campaign_contact: 0,
    total_pending_campaign_contact: 0,
    total_failed_campaign_contact: 0,
    total_delivered_campaign_contact: 0,
    total_read_campaign_contact: 0,
    total_clicked_count: 0,
    total_contacts_who_clicked: 0,
    total_replied_count: 0,
    total_contacts_who_replied: 0,
    campaign_contact_assignment_data: [],
    campaign_variable_data: [],
    campaign_contact_tag_filter: []
}; 

export const defaultRetargetCampaignPayload = (retargeted_from_campaign_id, contact_list_id, meta_integration_whatsapp_phone_number_id) => {
    return (
        {
            // "campaign_id": 0,
            "contact_list_id": contact_list_id,
            "meta_integration_whatsapp_phone_number_id": meta_integration_whatsapp_phone_number_id,
            "campaign_title": "", 
            "flag_template": true, 
            "flag_present_template": true,
            "retargeted_from_campaign_id": retargeted_from_campaign_id,
            "campaign_contact_filter_logic_operator": "AND", 
            "campaign_contact_filter": [],
        }
    );
}

export const filteredContacts = (campaignContactData, tagIds, contact_filter, selectedWhatsAppCampaign) => {
    if (campaignContactData) {
        const filteredContact = campaignContactData[0].contact?.filter((contact) => !(contact.flag_deleted));
        const contactFieldFilter = contact_filter.find((filter) => filter.campaign_contact_filter_type_name.toLowerCase() == "contact field"); 
        const executionStatusFilter = contact_filter.find((filter) => filter.campaign_contact_filter_type_name.toLowerCase() == "campaign execution status");

        if (tagIds.length === 0) {
            if(contactFieldFilter && contactFieldFilter.campaign_contact_filter_type_data?.some((type) => type.campaign_contact_filter_unique_value?.length > 0)){
                const filteredData = filteredContact?.filter((contact) => {
                    return  contactFieldFilter.campaign_contact_filter_type_data?.filter((fil) => fil.campaign_contact_filter_unique_value?.length > 0)?.every((filter) => {
                        return contact.contact_data?.some((data) => (data.contact_field_id == filter.campaign_contact_filter_unique_id) && (filter.campaign_contact_filter_unique_value.includes(data.contact_data_value)) )
                    })
                });
                return filteredData; 
            } else if(executionStatusFilter && executionStatusFilter.campaign_contact_filter_type_data?.length > 0){ 
                // console.log("selectedWhatsAppCampaign?.campaign_contact_assignment_data :: ", selectedWhatsAppCampaign?.campaign_contact_assignment_data)
                return selectedWhatsAppCampaign?.campaign_contact_assignment_data;
            }

            return campaignContactData[0].contact?.filter((contact) => !(contact.flag_deleted));
        }
        if (tagIds.length === 1) {
            if (campaignContactData[0].contact.find((contact) => tagIds.some((tag) => contact.contact_tag_assignment.some((tags) => tags.contact_tag_id === tag)))?.contact_tag_assignment.find((tag) => tag.contact_tag_id === tagIds[0])?.contact_tag_name.toLowerCase() === "all") {                
                if(contactFieldFilter && contactFieldFilter.campaign_contact_filter_type_data?.some((type) => type.campaign_contact_filter_unique_value?.length > 0)){
                    const filteredData = filteredContact?.filter((contact) => {
                        return  contactFieldFilter.campaign_contact_filter_type_data?.filter((fil) => fil.campaign_contact_filter_unique_value?.length > 0)?.every((filter) => {
                            return contact.contact_data?.some((data) => (data.contact_field_id == filter.campaign_contact_filter_unique_id) && (filter.campaign_contact_filter_unique_value.includes(data.contact_data_value)) )
                        })
                    });
                    return filteredData; 
                } else if(executionStatusFilter && executionStatusFilter.campaign_contact_filter_type_data?.length > 0){ 
                    return selectedWhatsAppCampaign?.campaign_contact_assignment_data;
                }

                return campaignContactData[0].contact?.filter((contact) => !(contact.flag_deleted));
            }
        }

        const tagFilteredContact = filteredContact?.filter((contact) => tagIds.some((tag) => contact.contact_tag_assignment.some((tags) => tags.contact_tag_id === tag)));
        if(contactFieldFilter && contactFieldFilter.campaign_contact_filter_type_data?.some((type) => type.campaign_contact_filter_unique_value?.length > 0)){
           
            const filteredData = filteredContact?.filter((contact) => {
                return  contactFieldFilter.campaign_contact_filter_type_data?.filter((fil) => fil.campaign_contact_filter_unique_value?.length > 0)?.every((filter) => {
                    return contact.contact_data?.some((data) => (data.contact_field_id == filter.campaign_contact_filter_unique_id) && (filter.campaign_contact_filter_unique_value.includes(data.contact_data_value)) )
                })
            }); 
            
            const finalFilteredData = tagFilteredContact.filter((contact) => {
                return filteredData.some((f) => (f.contact_id  == contact.contact_id))
            });
            return finalFilteredData;
        } else if(executionStatusFilter && executionStatusFilter.campaign_contact_filter_type_data?.length > 0){ 
            return selectedWhatsAppCampaign?.campaign_contact_assignment_data;
        }

        return campaignContactData[0].contact?.filter((contact) => !(contact.flag_deleted))?.filter((contact) => tagIds.some((tag) => contact.contact_tag_assignment.some((tags) => tags.contact_tag_id === tag)));
    }
    return [];
}

export const filteredRetargetContacts = (campaign_contact_assignment_data, filters, operator) => {

    let op = operator.toLowerCase();
    if (filters?.length > 0) {
        switch(op) {
            case "and":
                return campaign_contact_assignment_data?.filter((contact) => {
                    if (contact.flag_deleted) return false;

                    let finalReasult = filters.every((filter) => {
                        const status = filter.campaign_execution_status_name.toLowerCase();

                        if (status === 'failed') {
                            if (contact?.campaign_execution_tracking_data && contact?.campaign_execution_tracking_data?.length > 0) {
                                return contact?.campaign_execution_tracking_data?.some(entry =>
                                    entry?.message_status?.toLowerCase() === 'failed'
                                );
                            }
                            return contact
                        }

                        if (status == "clicked" || status == "replied") {
                            return contact?.campaign_analytics_status?.some((stat) => 
                                stat?.campaign_execution_status_name?.toLowerCase() === status
                            );
                        }

                        return contact?.campaign_execution_tracking_data?.some(entry =>
                            entry?.message_status?.toLowerCase() === status
                        );
                    });

                    return finalReasult
                });
            case "or":
                return campaign_contact_assignment_data?.filter((contact) => {
                    if (contact.flag_deleted) return false;

                    let finalReasult = filters.some((filter) => {
                        const status = filter.campaign_execution_status_name.toLowerCase();

                        if (status === 'failed') {
                            if (contact?.campaign_execution_tracking_data && contact?.campaign_execution_tracking_data?.length > 0) {
                                return contact?.campaign_execution_tracking_data?.some(entry =>
                                    entry?.message_status?.toLowerCase() === 'failed'
                                );
                            }
                            return contact
                        }

                        if (status == "clicked" || status == "replied") {
                            return contact?.campaign_analytics_status?.some((stat) => 
                                stat?.campaign_execution_status_name?.toLowerCase() === status
                            );
                        }

                        return contact?.campaign_execution_tracking_data?.some(entry =>
                            entry?.message_status?.toLowerCase() === status
                        );
                    });
                    return finalReasult
            });
        }
        return [];
    }
    else {
        return campaign_contact_assignment_data
    }
}

export const getCustamizedDateTime = () => {
    const now = new Date();

    const pad = (n) => n.toString().padStart(2, '0');

    const day = pad(now.getDate());
    const month = pad(now.getMonth() + 1);
    const year = now.getFullYear();

    let hours = now.getHours();
    const minutes = pad(now.getMinutes());
    const seconds = pad(now.getSeconds());

    const ampm = hours >= 12 ? "PM" : "AM"; 
    hours = hours % 12 || 12;
    const formattedHours = pad(hours);
    
    return `${day}/${month}/${year}_${formattedHours}:${minutes}:${seconds}${ampm}`;
}

export const getAllowedFileTye = (mediaType) => {
    switch(mediaType.toLowerCase()){
        case "image": 
            return '.jpg, .jpeg';
        case "video": 
            return '.mp4'; 
        case "document": 
            return ".pdf";
        default: 
            return "";
    }
} 

export const isCarouselTemplate = (messageTemplateDetail) => {
    if(messageTemplateDetail?.whatsapp_template_type?.name?.toLowerCase() == "carousel") return true;
    return false;
} 

export const getVisitWebsiteUrl = (whatsapp_template_button, whatsapp_template_dynamic_variable_id) => {
    if (!Array.isArray(whatsapp_template_button)) return "";

    for (const btn of whatsapp_template_button) {
        const buttonData = btn?.whatsapp_template_button_data;
        if (!Array.isArray(buttonData)) continue;

        for (const data of buttonData) {
            const subTypeFields = data?.whatsapp_template_button_sub_type_field_data;
            if (!Array.isArray(subTypeFields)) continue;

            for (const field of subTypeFields) {
                const variables = field?.whatsapp_template_button_field_data_variable;
                if (!Array.isArray(variables)) continue;

                for (const variable of variables) {
                    if (
                        variable?.whatsapp_template_dynamic_variable_id ===
                        whatsapp_template_dynamic_variable_id
                    ) {
                        return field?.whatsapp_template_button_sub_type_field_value ?? "";
                    }
                }
            }
        }
    }

    return "";
}

export const CAMPAIGN_DATE_TIME_FORMAT = "YYYY-MM-DD HH:mm";
export const CAMPAIGN_DATE_TIME_SECONDS_FORMAT = "YYYY-MM-DD HH:mm:ss";
export const CAMPAIGN_DESCRIPTION_TOOLTIP = "This description is passed to the AI as context for the chatbot. Describe the campaign's purpose, offer and what the customer should expect. Maximum 1024 characters.";

export const CAMPAIGN_STATUS = {
    DRAFT: "Draft",
    IN_PROGRESS: "In Progress",
    SCHEDULED: "Scheduled",
    COMPLETED: "Completed",
    PAUSED: "Paused",
    ARCHIVED: "Archived",
    SENT: "Sent",
    PENDING: "Pending",
    FAILED: "Failed",
    DID_NOT_SEND: "Did Not Send"
}

export const CAMPAIGN_ACTION_BUTTONS = {
    EXECUTE: "Execute",
    RESUME: "Resume",
    PAUSE: "Pause",
    RETARGET: "Retarget",
    ARCHIVE: "Archive"
}

export const CAMPAIGN_STATUS_MESSAGES = {
    EXECUTE_SUCCESS: 'Campaign Executed Successfully',
    RESUME_SUCCESS: 'Campaign Resumed Successfully',
    PAUSE_SUCCESS: 'Campaign Paused Successfully',
    CAMPAIGN_DELETE: 'Campaign Deleted Successfully',
    ARCHIVE_SUCCESS: 'Campaign Archived Successfully'
}

export const getColorFromStatus = (executionStatus) => {
    const executionStatusName = toScreamingSnakeCase(executionStatus);

    return CAMPAIGN_STATUS_COLORS[CAMPAIGN_STATUS[executionStatusName]]?.TEXT_COLOR ?? CAMPAIGN_STATUS_COLORS["DEFAULT"].TEXT_COLOR;
}

export const getWhatsAppPerMessagePricing = (messageTemplateDetail, countryCode, whatsAppPricingData) => {
    const currency = messageTemplateDetail?.currency;
    const templateCategory = messageTemplateDetail?.whatsapp_template_data?.[0]?.whatsapp_template_category_name?.toLowerCase();

    const regionNames = new Intl.DisplayNames(["en"], { type: "region" });
    const countryName = regionNames.of(countryCode?.toUpperCase());

    const whatsAppPricing = whatsAppPricingData?.find((price) => {
        if(price?.market?.toLowerCase() == countryName?.toLowerCase() && price?.currency?.toLowerCase() == currency?.toLowerCase()){
            return true;
        }
        return false;
    });

    let price = 0;
    if(whatsAppPricing){
        price = whatsAppPricing[templateCategory];
    }

    return `${price} ${currency}`;
}